"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../components");
var copy_1 = require("../../../copy");
var sandwich_ids_1 = require("../../../sandwich-ids");
var section_ids_1 = require("../../../section-ids");
var components_2 = require("./components");
var PlanUI = function (_a) {
    var _b = _a.plans, electricity = _b.electricity, gas = _b.gas;
    var _c = (0, core_1.useComponents)(), Heading1 = _c.Heading1, Card = _c.Card, Stack = _c.Stack;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var noPlans = !electricity.length && !gas.length;
    if (noPlans) {
        return react_1.default.createElement(components_2.PlanNotFoundSection, { id: section_ids_1.PLAN_SECTION_ID });
    }
    return (react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.planPage.page },
        react_1.default.createElement("section", { id: section_ids_1.PLAN_SECTION_ID, "data-testid": section_ids_1.PLAN_SECTION_ID },
            react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
                react_1.default.createElement(Card, null,
                    react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.planPage.intro },
                        react_1.default.createElement(Heading1, null, copy('title')))),
                electricity.map(function (electricityPlan, index) {
                    return (react_1.default.createElement(components_1.Contract, { key: "eletricity-".concat(index), fuelType: "electricity", plan: electricityPlan }));
                }),
                gas.map(function (gasPlan, index) {
                    return (react_1.default.createElement(components_1.Contract, { key: "gas-".concat(index), fuelType: "gas", plan: gasPlan }));
                })))));
};
exports.PlanUI = PlanUI;
